/**
 * Sentry init — no-op unless REACT_APP_SENTRY_DSN is set AND @sentry/react is installed.
 *
 * To activate:
 *   1. cd frontend && npm install @sentry/react
 *   2. Set REACT_APP_SENTRY_DSN in .env (https://sentry.io project DSN)
 *   3. Rebuild — errors will start flowing to Sentry automatically.
 *
 * Uses dynamic import so the bundle stays clean for users without Sentry.
 */
export const initSentry = async () => {
    const dsn = process.env.REACT_APP_SENTRY_DSN;
    if (!dsn) return;

    try {
        // Hidden from webpack so the bundle compiles without @sentry/react installed.
        // eslint-disable-next-line no-new-func
        const dynamicImport = new Function('m', 'return import(m)');
        const Sentry = await dynamicImport('@sentry/react');
        Sentry.init({
            dsn,
            environment: process.env.REACT_APP_SENTRY_ENV || process.env.NODE_ENV || 'production',
            // Conservative defaults — bump tracesSampleRate once you confirm volume.
            tracesSampleRate: 0.1,
            replaysSessionSampleRate: 0,
            replaysOnErrorSampleRate: 1.0,
            integrations: (defaults) => defaults,
        });
    } catch (err) {
        // Package not installed yet — leave a single dev console hint and move on.
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.info(
                '[sentry] DSN is set but @sentry/react is not installed. Run: npm install @sentry/react',
            );
        }
    }
};

export default initSentry;
